export const H = ({ children, sub, action }) => (
  <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
    <div><h1 className="font-display text-5xl">{children}</h1>{sub && <p className="text-sm text-slate-400">{sub}</p>}</div>{action}
  </div>
);
export const inp = "w-full rounded-lg border border-white/10 bg-black/30 px-3 py-2 text-sm outline-none focus:border-amber-400";
export const btn = "rounded-full bg-amber-400 px-5 py-2 text-sm font-bold text-black hover:bg-amber-300 disabled:opacity-50";
export const btn2 = "rounded-full border border-white/15 px-4 py-2 text-sm hover:border-amber-400";
export const card = "rounded-2xl border border-white/5 bg-[#12121A] p-5";
